import {Order} from '@/typedef/order';
import _ from 'lodash';
import {Company} from '@/typedef/vendor';

// 根据材料的单位调整数量,根据材料单位的不同，如，米，码千克等，转换数量
function quantityTransferByUnit(value, item) {

    // 面料的计算分针织面料和梭织面料，计算总数量的时候有区分。梭织面料：按单位来，“米”的时候正常，“码”的时候，总数量计算【单耗（米）损耗成衣数量/0.9144】转换成码的总数量值。针织面料：按单位来，“千克”，总数量计算【单耗（米）损耗成衣数量*门幅（米）*克重kg】转还成千克的总数量值

    if (item && item.unitType == '码') {
        return value / 0.9144;
    } else if (item && item.unitType == '千克') {
        return value * item.width * item.gramWeight;
    } else {
        return value;
    }

}

function getBomId(boms, colorDimId) {
    for (let i = 0; i < boms.length; i++) {
        for (let j = 0; j < boms[i].dims.length; j++) {
            if (boms[i].dims[j].dimType == 'color' && boms[i].dims[j].id == colorDimId) {
                return boms[i].id;
            }
        }
    }
    return -1;
}

// 我们来计算一下，所谓的，订单数量.这是动态变动的.我不计在orderBudget里
export default function calculateQuantity(state) {
    if (_.isEmpty(state.order)) {
        // @ts-ignore
        return {};
    }
    const order = state.order as Order;
    console.log('计算数量------',);

    //clothesStuffList
    //boms 里有
    const stuffQtyTable = _.filter(order.qtyTable, {refTo: 'CLOTHES_STUFF'});

    const factoryInOrderQty = _.filter(order.qtyTable, {refTo: 'FACTORY_IN_ORDER'});

    // console.log("stuffQty", stuffQtyTable);
    // console.log("factoryInOrderQty", factoryInOrderQty);


    // 之后特殊材料还要补上的..
    const dimQuantity = _.map(stuffQtyTable, q => {
        return {stuffId: q.refId, sizeDimId: q.sizeDimId, colorDimId: q.colorDimId, quantity: 1};
    });
    // 上面这个只说的是，某材料，在某衣服的1规格1尺码下面存不存在.
    //现在问题在于，在颜色尺码固定的情况下，上面的材料qty在factoryInOrder可以找到不止一份对照！

    const productStuffs: any[] = [];
    _.each(factoryInOrderQty, f => {
        //如果上面的那个颜色尺码，能对应上这里，那就要生成一份数据..
        _.each(dimQuantity, q => {
            if (f.colorDimId == q.colorDimId && f.sizeDimId == q.sizeDimId) {
                productStuffs.push({
                    factoryId: null,
                    factoryQtyId: f.id,
                    factoryInOrderId: f.refId,
                    clothesQuantity: f.quantity,
                    stuffId: q.stuffId,
                    sizeDimId: f.sizeDimId,
                    colorDimId: f.colorDimId,
                    quantity: 0,//
                    supplierId: null, //
                    stuffType: null,
                });
            }
        })
    });
    // 知道了factoryInOrderId,应该就能知道，加工厂. 也可以放上面去，不过考虑到以后可能把这部分计算整合直接丢后台，写的时候要分开
    _.each(productStuffs, p => {
        p.factoryId = _.chain(order.factoryList).find({id: p.factoryInOrderId}).get('factoryId', null).value();
        let stuffIndex = _.findIndex(order.clothesStuffList, {id: p.stuffId});
        if (stuffIndex > -1) {
            const stuff = order.clothesStuffList[stuffIndex];
            p.supplierId = stuff.vendorId;
            p.stuffType = stuff.stuffType;
            if (['fabric', 'sewing_accessories', 'packaging_accessories'].indexOf(p.stuffType) > -1) {
                p.quantity = quantityTransferByUnit(p.clothesQuantity * (1 + stuff.loss / 100) * stuff.consumption, stuff);
            }

        }
        p.bomId = getBomId(order.boms, p.colorDimId);
        p.orderId = state.order.data.id;
    })

    //特殊材料的计算不是以上面的方式为准的.
    for (let i = 0; i < productStuffs.length; i++) {
        if (productStuffs[i].stuffType == 'special_accessories') {
            productStuffs.splice(i, 1);
            i--;
        }
    }
    productStuffs.push(..._.chain(order.clothesStuffList).filter({stuffType: 'special_accessories'}).map(o => {
        return {
            orderId: order.data.id,
            supplierId: o.vendorId,
            factoryId: null, //连加工厂都不知道往哪里发啊..
            factoryInOrderId: null,
            stuffId: o.id,
            clothesQuantity: 0, //特殊材料对应的衣服数量没有意义
            colorDimId: 0, //同样的，这东西不能算在部件里，用负数的话，又不对..似乎只能0啊？只能0或者null
            sizeDimId: 0,
            quantity: o.totalPieces,
            bomId: 0,//
            stuffType: o.stuffType,
        }
    }).value());
    //对于特殊辅料
    // console.log("分加工厂材料数量统计,只显示红皮", _.filter(productStuffs, {stuffId: 618}));
    // 到这一步的时候，我们缺一个特殊材料..也许应该把材料的类型丢上去
    return productStuffs;
    // return _.filter(productStuffs, o => ['fabric', 'sewing_accessories', 'packaging_accessories', 'special_accessories'].indexOf(o.stuffType) > -1);
}
